import { Link } from "react-router-dom";

import styles from "../layout.module.css";
import { OrgLogo } from "Components";
import { useAppContext } from "Context/AppContext";
import {
  AccountDropdown,
  ChatNotiDropdown,
  NotificationDropdown,
  ServiceDropdown,
} from "./Components";
import { ResponseDataType, getRequest } from "api";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { NotiResType, NotificationInfo } from "./type";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import { IconButton, Tooltip } from "@mui/material";
import { Popup } from "Components";
import CreateOrganizationPopup from "Components/Popup/CreateOrganizationPopup";

// kiểu dữ liệu đại diện cho một tổ chức trong hệ thống.
export interface OrganizationInfo {
  id: string;
  name: string;
  logo: string;
  numberOfMembers: number;
  memberAvatar: string;
  memberId: string;
  memberDepartmentCode: string;
}

// dữ liệu trả về từ API danh sách tổ chức.
interface OrgListDto {
  orgId?: string;
  orgList: OrganizationInfo[];
  memberId?: string;
}

export default function Header() {
  const { currentOrg, currentOrgInfo, showNoteApp, setShowNoteApp } =
    useAppContext();
  const [notiList, setNotiList] = useState<NotificationInfo[]>([]);
  const [chatNotiList, setChatNotiList] = useState<NotificationInfo[]>([]);
  const [numberOfNotiNotSeen, setNumberOfNotiNotSeen] = useState(0);
  const [numberOfChatNotiNotSeen, setNumberOfChatNotiNotSeen] = useState(0);
  const [isOpenCreatePopup, setIsOpenCreatePopup] = useState<boolean>(false);
  const [orgList, setOrgList] = useState<OrganizationInfo[] | undefined>();
  // const { customerId } = useParams();
  const customerId = localStorage.getItem("customerId");
  useEffect(() => {
    if (isOpenCreatePopup) {
      setShowNoteApp(false);
    }
  }, [isOpenCreatePopup]);
  const getOrgList = async () => {
    try {
      const response: ResponseDataType<OrgListDto> = await getRequest(
        `/customer/get-org-list?${
          localStorage.getItem("customerId")
            ? `&customerId=${localStorage.getItem("customerId")}`
            : ""
        }${
          localStorage.getItem("organizationId")
            ? `&orgId=${localStorage.getItem("organizationId")}`
            : ""
        }`
      );

      if (response.code) {
        toast.error(response.message);
      } else {
        if (response.data?.orgId) {
          localStorage.setItem("organizationId", response.data.orgId);
        }
        setOrgList(response.data?.orgList);
      }
    } catch (error) {
      console.error("Lỗi trong getOrgList:", error);
      toast.error("Không thể lấy danh sách tổ chức!");
    }
  };

  // useEffect(() => {
  //   getOrgList();
  // }, []);

  useEffect(() => {
    const getNotifications = async () => {
      if (!currentOrg) return;
      const res: ResponseDataType<NotiResType> = await getRequest(
        `/notification/get-notification?orgId=${currentOrg}`
      );

      if (res.code) {
        toast.error(res.message);
      } else {
        setNotiList(res.data?.notiList || []);
        setChatNotiList(res.data?.chatNotiList || []);
      }
    };

    getNotifications();
  }, [currentOrg]);

  return (
    <div
      className={styles.header}
      style={{ width: showNoteApp ? "calc(100vw - 300px)" : "100%" }}
    >
      <Link to="/" className={styles.organization}>
        <OrgLogo
          className={styles.organization_logo}
          src={currentOrgInfo?.logo}
        />
        {/* <p className={styles.organization_name}>Adot Workspace</p> */}
      </Link>

      <div className={styles.account}>
        <div style={{ marginRight: "6px" }}>
          <Tooltip title="Tạo tổ chức mới">
            <IconButton
              sx={{
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
              onClick={() => setIsOpenCreatePopup(true)}
            >
              <DomainAddIcon
                sx={{
                  cursor: "pointer",
                  fontSize: "26px",
                  color: "black",
                  mb: "2px",
                }}
              />
            </IconButton>
          </Tooltip>
        </div>

        <ServiceDropdown />
        <>
          <ChatNotiDropdown
            chatNotiList={chatNotiList}
            numberOfChatNotiNotSeen={numberOfChatNotiNotSeen}
            setChatNotiList={setChatNotiList}
            setNumberChatNotiOfNotSeen={setNumberOfChatNotiNotSeen}
          />
          <NotificationDropdown
            notiList={notiList}
            numberOfNotiNotSeen={numberOfNotiNotSeen}
            setNotiList={setNotiList}
            setNumberNotiOfNotSeen={setNumberOfNotiNotSeen}
          />
        </>
        <AccountDropdown />
      </div>
      {isOpenCreatePopup && (
        <Popup close={() => setIsOpenCreatePopup(false)}>
          <CreateOrganizationPopup
            customerId={customerId as string}
            close={() => setIsOpenCreatePopup(false)}
            getOrgList={() => getOrgList()}
          />
        </Popup>
      )}
    </div>
  );
}
